import { render } from "./Route.vue?vue&type=template&id=535365a7"
import script from "./Route.vue?vue&type=script&lang=ts"
export * from "./Route.vue?vue&type=script&lang=ts"

import "./Route.vue?vue&type=style&index=0&id=535365a7&lang=scss"
script.render = render

export default script